export const site_url='https://admin.apmsmarthub.com/api';
export const site_url_img='https://admin.apmsmarthub.com/public/storage';
export const invoice_img='assets/img/invoice.png';
export const nodata='assets/ZLoYNL4NvA.json';